import React from "react";
import bannerImage from "../../assets/images/home/women.png";
import { Link } from "react-router-dom";
const HomeBannerTwo = () => {
  return (
    <div className="w-full flex pb-7 xl:pb-16 justify-center flex-col items-center text-white relative  sm:pt-[70px] pt-32 xl:pt-64">
      {/* Container Wrapper */}
      <div
        className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto w-full"
        data-aos="fade-up"
      >
        <h2
          className="sm:text-[25px] text-[32px] xl:text-[52px] w-[85%] lg:w-[70%] xl:w-[60%]  3xl:w-[70%] mx-auto text-center z-20 font-extralight font-lexend xl:leading-[62px] tracking-wide"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          GETTING A GOOD NIGHT'S SLEEP SHOULDN'T BE HARD.
        </h2>

        <div className="grid lg:grid-cols-2 mt-20 mb-32 xl:my-40 lg:gap-20">
          <div className="w-full xl:pb-10">
            <img
              src={bannerImage}
              className="w-full object-cover"
              alt=""
              data-aos="fade-up"
              data-aos-delay="200"
            />
          </div>

          <div className="xs:ps-6 ps-8 md:ps-0 pe-0 lg:pe-6 2xl:ps-16 flex justify-start items-start  flex-col">
            <h2
              className="sm:text-[25px] text-[40px] xl:text-[50px] md:hidden lg:block hidden font-extralight font-lexend leading-tight tracking-wide "
              data-aos="fade-up"
              data-aos-delay="300"
            >
              BUT THEN,
              <br />
              WHY IS IT THAT <br /> YOU ALWAYS <br /> WAKE UP TIRED?
            </h2>
            <h2
              className="sm:text-[25px] text-[40px] xl:text-[50px] md:hidden  block font-extralight font-lexend leading-tight tracking-wide "
              data-aos="fade-up"
              data-aos-delay="300"
            >
              BUT THEN,
             
              WHY IS IT THAT  YOU ALWAYS  WAKE UP TIRED?
            </h2>
            <h2
              className=" text-[40px] md:block lg:hidden hidden  font-extralight font-lexend leading-tight tracking-wide "
              data-aos="fade-up"
              data-aos-delay="300"
            >
              BUT THEN,
              
              WHY IS IT THAT <br /> YOU ALWAYS  WAKE UP TIRED?
            </h2>

            <h2
              className="my-5 xl:my-12 sm:text-[15px] text-[27px] font-normal font-lexend 2xl:leading-[3rem] tracking-wide "
              data-aos="fade-up"
              data-aos-delay="400"
            >
              (Hint: It's not you. <br /> It's the way the mattress <br />
              industry operates.)
            </h2>

            <Link
              to="/about"
              className="relative sm:px-1 px-6 sm:py-1.5 py-3 sm:w-32 sm:text-[15px] w-48 text-[22px]  tracking-wider font-normal font-lexend  bg-transparent isolation-auto z-10 border-2 border-[#f4e391] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-[#38693e] before:-left-full before:hover:left-0 before:rounded-full before:bg-[#f4e391] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#f4e391] shadow-sm gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal sm:hover:text-[15px] hover:text-[22px]"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              READ UP
            </Link>
          </div>
        </div>

        <div className="absolute xl:bottom-44 lg:bottom-12 -bottom-5 left-1/2 -translate-x-1/2 ">
          <p
            className="xl:text-[143px] lg:text-[110px] md:text-[72px] md:text-6xl text-4xl sm:text-[34px] text-center text-[#94c99b] font-thin font-lexend xl:leading-[8rem]"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            #RETHINKSLEEP
          </p>
          <p
            className="xl:text-[36px] md:text-2xl  text-[12px] font-normal font-lexend lg:pt-4 pt-4 text-center"
            data-aos="fade-up"
            data-aos-delay="700"
          >
            Choose the sleep that understands you
          </p>
        </div>
      </div>
      {/* End Container */}
    </div>
  );
};

export default HomeBannerTwo;
